import axios from "axios";
import { serverAddress } from "../../constant";
import cookie from "js-cookie";

const LawContactAPI = {
  getAll: (params) => {
    let url =
      serverAddress +
      `/law/contact/get-all?page=${params?.page}&limit=${params?.limit}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  findOne: (id) => {
    let url = serverAddress + `/law/contact/get/${id}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  total: () => {
    let url = serverAddress + `/law/contact/get/total/contact`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
};

export default LawContactAPI;
